import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

const scrollUpElement = document.getElementById("scroll-up");

if (scrollUpElement !== null) {

  const offsetFromTop = scrollUpElement.getAttribute("data-offset-from-top") ?? 100; // if not set default is 100px
  const scrollHandle = () => {
    if (document.body.scrollTop > offsetFromTop || document.documentElement.scrollTop > offsetFromTop) {
      scrollUpElement.classList.add("--active");
    } else {
      scrollUpElement.classList.remove("--active");
    }
  };

  window.onscroll = scrollHandle;

  scrollUpElement.addEventListener("click", () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}

